import { ADD_GTAG_IDENTIFIERS } from '@/configs/gtag';

type GIdDataType = {
  module: string;
  screen: string;
  section: string;
  component: string;
  disabled?: boolean;
  opened?: boolean;
};

function getGid({
  module,
  screen,
  section,
  component,
  disabled,
  opened,
}: GIdDataType) {
  return `${module}_${screen}_${section}_${component}${
    disabled ? 'Disabled' : ''
  }${opened ? 'Opened' : ''}`;
}

function setGid({
  el,
  module,
  screen,
  section,
  component,
  disabled,
  opened,
}: GIdDataType & { el: HTMLElement }) {
  if (ADD_GTAG_IDENTIFIERS) {
    let element: HTMLElement = el;

    if (element.tagName === 'LABEL') {
      element = el.querySelector('input') ?? el;
    }

    const gid = getGid({
      module,
      screen,
      section,
      component,
      disabled,
      opened,
    });
    element.setAttribute('data-gid', gid);
  }
}

export default {
  mounted(el: HTMLElement, { value }: { value: GIdDataType | undefined }) {
    if (value) {
      const { module, screen, section, component, disabled, opened } = value;
      setGid({ el, module, screen, section, component, disabled, opened });
    }
  },
  updated(el: HTMLElement, { value }: { value: GIdDataType | undefined }) {
    if (value) {
      const { module, screen, section, component, disabled, opened } = value;
      setGid({ el, module, screen, section, component, disabled, opened });
    }
  },
};
